import { checkSilentAuthStatus } from '@seek/ssr-auth/client';

import { isSSAEnabled } from 'src/config';

import { fireAuthMetric } from '.';

export const fireAuth0SSOSession = async () => {
  if (isSSAEnabled) {
    const result = await checkSilentAuthStatus();
    fireAuthMetric({
      name: 'auth0SSOSession',
      isAuthenticated: result.isAuthenticated,
      error: result.error,
    });
  }
};
